// Copy for the "try the new navigation" coachmark shown on the old nav. Shared
// between the desktop anchor (SettingsNav) and the mobile anchor (MobileNav's
// menu button) so the two don't drift.
export const OLD_NAV_HINT = {
  title: "Try out the new navigation here",
  description:
    "When you're ready, you can switch to the new navigation in your account menu."
}
